import React from 'react';
import IconButton from 'material-ui/IconButton';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
import IconMenu from 'material-ui/IconMenu';
import MenuItem from 'material-ui/MenuItem';
import style from '../../../styles/styles';
import PropTypes from 'prop-types';
import {black, grey400} from 'material-ui/styles/colors';
import Avatar from 'material-ui/Avatar';
import {ListItem} from 'material-ui/List';
import AdminService, {ADMIN} from "../../../services/admin";
import styles from './Media.css';
import MediasService from "../../../services/medias";
import Timestamp from 'react-timestamp';
import {Chip} from "material-ui";
import withTranslation from "../../../hoc/withTranslation";

class Media extends React.Component {

    static propTypes = {
        media: PropTypes.object.isRequired,
        user: PropTypes.object.isRequired,
        handleRemove: PropTypes.func,
        handleEdit: PropTypes.func
    };

    // Handler

    handleDownloadMedia = (media) => {
        window.open(media.link);
    };

    // Render

    renderRightIconButton(media) {
        if (!this.props.user) {
            return
        }

        const iconButtonElement = (
            <IconButton
                touch={true}
                tooltipPosition="bottom-left"
            >
                <MoreVertIcon color={grey400}/>
            </IconButton>
        );

        return (
            <IconMenu
                iconButtonElement={iconButtonElement}
                listStyle={style.list}
                anchorOrigin={{horizontal: 'right', vertical: 'top'}}
                targetOrigin={{horizontal: 'right', vertical: 'top'}}
            >
                <MenuItem onClick={() => this.handleDownloadMedia(media)}>
                    {this.props.t('generic.download')}
                </MenuItem>
                {AdminService.isAuthorized(ADMIN, this.props.user) && this.props.handleEdit &&
                    <MenuItem onClick={() => this.props.handleEdit(media)}>
                        {this.props.t('generic.edit')}
                    </MenuItem>
                }
                {AdminService.isAuthorized(ADMIN, this.props.user) && this.props.handleRemove &&
                    <MenuItem onClick={() =>  this.props.handleRemove(media)}>
                        {this.props.t('generic.remove')}
                    </MenuItem>
                }
            </IconMenu>
        )
    }

    render() {
        const media = this.props.media;
        let leftAvatar;

        if (MediasService.isImage(media)) {
            leftAvatar = <Avatar
                src={media.link}
                style={style.image.cover}
            />;
        } else {
            leftAvatar = <Avatar
                backgroundColor={black}
                icon={MediasService.iconForMedia(media)}
                style={style.image.cover}
            />;
        }

        return (
            <ListItem
                leftAvatar={leftAvatar}
                primaryText={
                    <div>
                        {media.name}
                        {media.tag &&
                            <Chip style={{...styles.chip, ...style.chip}}>
                                {media.tag}
                            </Chip>
                        }
                    </div>
                }
                secondaryText={
                    <div>
                        {media.mime_type}
                        {media.created_at && <span>  - <Timestamp time={media.created_at} format='full' twentyFourHour/></span>}
                    </div>
                }
                rightIconButton={this.renderRightIconButton(media)}
            />
        );
    }
}

export default withTranslation(Media);



// WEBPACK FOOTER //
// src/components/media/Media/Media.js